<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('traininglocations.Header') }}</h2>
            </div>
        </div>
        <div id="image_holder" class="imageHolder" style="height:850px; display:flex">
            <tabstrip :selected="selected" @select="onSelect" v-if="locations">
                <tabstripTab v-for="location in locations" :title="location.kurzbezeichnung" :key="location.prim">
                    <br />
                    <div class="locationContent"><strong>{{ location.kurzbezeichnung }}:</strong> {{ location.hallenname }}</div>
                    <br />
                    <img style="width:100%;max-width:300px;" v-bind:src="url + location.bildpfad" alt="" />
                    <br />
                    <div class="locationContent"><strong>{{ $t('traininglocations.Adress') }}</strong> {{ location.adresse}}</div>
                    <br />
                    <div class="locationContent"><strong>{{ $t('traininglocations.Directions') }}</strong> {{ location.beschreibung }}</div>
                    <a v-bind:href="url + location.linkPDF">{{ $t('traininglocations.DirectionsPDF') }}</a>
                    <br />
                    <br />
                    <br />
                    <div v-html="location.googleMaps"></div>
                </tabstripTab>
            </tabstrip>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/classes/eventBus.js';
    import { TabStrip, TabStripTab } from '@progress/kendo-vue-layout';
    import axios from 'axios';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'tabstrip': TabStrip,
            'tabstripTab': TabStripTab,
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                theImage: '',
                selected: 0,
                locations: []
            }
        },
        computed: {
        },
        created() {
            this.url = config[0].BaseUrl
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
            const urlLocation = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Trainingsorte"
            axios.get(urlLocation)
                .then(response => {
                    this.locations = response.data;
                })
                .catch(error => {
                    console.log(error)
                    this.errored = true
                })
                .finally(() => this.loading = false);
            },
        methods: {
            onSelect: function (e) {
                this.selected = e.selected;
            }
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>